import { IonButton , IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonCheckbox, IonLoading , IonSpinner , useIonViewDidEnter , useIonViewWillEnter, useIonViewWillLeave } from "@ionic/react";
import Box from "@mui/material/Box";
import { DataGrid , deDE } from "@mui/x-data-grid";
import { useContext , useEffect , useState } from "react";
import { useHistory } from 'react-router-dom';
import { defColumn , exportTableData } from './_HelperFunctions' ;
import { Hourglass, ThumbsDown , ThumbsUp } from 'react-ionicons';
import { AppContext } from "../contexts/app_context";
import './table_einweisungen_grid.css'

export default function UnterweisungenMatrix() {
  useIonViewWillEnter( () => setMatrixLoading( true ) ) ;
  useIonViewDidEnter(() => {
    appUnterweisungenMatrixBuildNewChange( true ) ;
    // setMatrixLoading( true )
    // console.log( 'ionViewDidEnter table_matrix' ) ;
  });
  useIonViewWillLeave(() => {
    setTableData( [] )
    appUnterweisungNeuTeilnehmerChange( '' ) ;
    appUnterweisungNeuThemaChange( '' ) 
    // console.log( 'ionViewWillLeave table_matrix' ) ;
  });
  /** Component Environment */
    const { appUnterweisungIdChange , appUnterweisungen , appUnterweisungenListeFetchState , appUnterweisungenMatrixBuildNew ,appUnterweisungenMatrixBuildNewChange , appUnterweisungNeuTeilnehmer , appUnterweisungNeuTeilnehmerChange , appUnterweisungNeuThema , appUnterweisungNeuThemaChange , appUnterweisungsthemen , appMitarbeiterListe , appViewSwitchChange } = useContext( AppContext ) ;
    const [ tableData , setTableData ] = useState( Array() ) ;
    const [ unterweisungNeuThemaTitel , setUnterweisungNeuThemaTitel ] = useState( '' ) ;
    const history = useHistory();
    const [ localUnterweisungsthemen , setLocalUnterweisungsthemen ] = useState( appUnterweisungsthemen ) ;
    const [ matrixLoading , setMatrixLoading ] = useState( true ) ;
    const [pageSize, setPageSize] = useState(50);
      // NB: "fetchState" bzw. "setFetchState" momentan nur für Syntax getDate()
  /** Component Helpers */
    const matrixCheckbox = 
      ( unterweisungsthemaId , mitarbeiter , unterweisungsthemaTitel ) =>
        {
          //#region Numerische IDs via Prä- und Suffix eindeutig machen
            let myAppUnterweisungNeuTeilnehmer = ',' + appUnterweisungNeuTeilnehmer + ',' ;
            let myMitarbeiter =  ',' + mitarbeiter + ',' ;
              //#endregion Numerische IDs via Prä- und Suffix eindeutig machen
          //#region "mitarbeiter" hinzufügen oder entfernen
            if( myAppUnterweisungNeuTeilnehmer.includes( myMitarbeiter ) ) {
              // alert( '"' + myMitarbeiter + '" IST in "' + myAppUnterweisungNeuTeilnehmer + '"' ) ;
              /** "mitarbeiter" lokal entfernen, weil noch für "thema" unten benötigt */
                myAppUnterweisungNeuTeilnehmer = myAppUnterweisungNeuTeilnehmer.replace( myMitarbeiter , '' ) ;
              appUnterweisungNeuTeilnehmerChange( myAppUnterweisungNeuTeilnehmer ) ;
            } else {
              // alert( '"' + myMitarbeiter + '" ist NICHT in "' + myAppUnterweisungNeuTeilnehmer + '"' ) ;
              /** "mitarbeiter" lokal hinzufügen, weil noch für "thema" unten benötigt */
                myAppUnterweisungNeuTeilnehmer += ',' + mitarbeiter ;
              appUnterweisungNeuTeilnehmerChange( myAppUnterweisungNeuTeilnehmer ) ;
            }
              //#endregion "mitarbeiter" hinzufügen oder entfernen
          //#region "unterweisungsthemaId" hinzufügen oder entfernen wenn alle "mitarbeiter" entfernt wurden
            if( myAppUnterweisungNeuTeilnehmer.replaceAll( ',' , '' ) !== '' ) {
              // alert( 'Mitarbeiter "' + myAppUnterweisungNeuTeilnehmer + '" => Thema dazu' ) ;
              appUnterweisungNeuThemaChange( unterweisungsthemaId ) ;
              setUnterweisungNeuThemaTitel ( unterweisungsthemaTitel ) ;
            } else {
              // alert( 'Mitarbeiter "' + myAppUnterweisungNeuTeilnehmer + '" => Thema weg' ) ;
              appUnterweisungNeuThemaChange( '' ) ;
              setUnterweisungNeuThemaTitel( '' ) ;
            }
              //#endregion "unterweisungsthemaId" hinzufügen oder entfernen wenn alle "mitarbeiter" entfernt wurden
        }
    ;
    const matrixHourglass =
      ( unterweisungsthemaId , mitarbeiter , next ) =>
        {
          // ! s. Ticket 27/5/22: Funktionalität zurückgestellt als "Erweiterungs-Feature"
          appViewSwitchChange( true ) ;
          appUnterweisungIdChange ( next ) ;
          history.push( '/unterweisung/' + next ) ;
        }
    ;
    const matrixThumb = 
      ( unterweisungsthemaId , mitarbeiter , next ) =>
        {
          appViewSwitchChange( true ) ;
          appUnterweisungIdChange ( next ) ;
          history.push( '/unterweisung/' + next ) ;
        }
    ;
    const setColumns = () => {
      const mkUnterweisungsColumns = ( colsArray )  => 
        {
          localUnterweisungsthemen
            .forEach(
              ( { UnterweisungsthemenId , UnterweisungsthemenTitel } ) =>
                {
                  if(
                    1 === 1
                  )
                    {
                      let newCol =
                        {
                          align: 'center' ,
                          field: 'matrixUnterweisungsthema' + UnterweisungsthemenId ,
                          flex: 0 ,
                          description: UnterweisungsthemenTitel ,
                          headerName: UnterweisungsthemenTitel ,
                          headerClassName: "super-app-theme--header , datagrid-vertical-head",
                          width: 120 ,
                          renderCell: ( params ) => {
                            // return <><IonCheckbox onClick={ () => matrixCheckbox( UnterweisungsthemenId , params.row.MitarbeiterId ) } />&nbsp;<ThumbsUp color = { params.row.value.split(1)[0] } onClick={ () => matrixThumb( UnterweisungsthemenId , params.row.MitarbeiterId ) }/>params.row.value.split(1)[1]==''?&nbsp;<Hourglass onClick={ () => matrixHourglass( UnterweisungsthemenId , params.row.MitarbeiterId , UnterweisungsthemenTitel) } />:''</>
                            let myData = params.row[ 'matrixUnterweisungsthema' + UnterweisungsthemenId ].split( ',' ) ;
                            let mitarbeiterRowInfo = params.row.Personalnummer + ' ' + params.row.Nachname + ', ' + params.row.Vorname + ' (' + params.row.Taetigkeit + ' ' + params.row.Abteilung + ')' ;
                            return (
                              <>
                                { 
                                  myData[0] === 'red'
                                    ? 
                                      <ThumbsDown
                                        color = { myData[0] }
                                        style = { { cursor: 'not-allowed' } }
                                        title = { 'Keine gültige Schulung gefunden für ' + mitarbeiterRowInfo }
                                      />
                                    :
                                      <ThumbsUp
                                        color = { myData[0] }
                                        onClick = { () => matrixThumb( UnterweisungsthemenId , params.row.MitarbeiterId , myData[ 1 ] ) }
                                        style = { { cursor: 'pointer' } }
                                        title = { 'zur letzten stattgefundenen Schulung für ' + mitarbeiterRowInfo }
                                      />
                                }
                                &nbsp;
                                {
                                  myData[ 2 ]
                                    ? 
                                      <Hourglass
                                        onClick = { () => matrixHourglass( UnterweisungsthemenId , params.row.MitarbeiterId , myData[ 2 ] ) }
                                        style = { { cursor: 'pointer' } }
                                        title = { 'zur nächsten geplanten Schulung für ' + mitarbeiterRowInfo }
                                      />
                                    :
                                      <IonCheckbox
                                        /** "checked" explizit für Reset bei Re-Rendering */
                                          // checked = { false }
                                        onClick = { () => matrixCheckbox( UnterweisungsthemenId , params.row.MitarbeiterId , UnterweisungsthemenTitel ) }
                                        title = { 'Neue Schulung planen mit ' + mitarbeiterRowInfo }
                                        />
                                }
                              </>
                            )
                          }
                        }
                      colsArray.push( newCol ) ;
                    }
                  ;
                }
            )
        }
      let cols =
        [
          defColumn( 'MitarbeiterId' , 'ID' , 0 ) ,
          defColumn( 'Personalnummer' , 'Personalnummer' , 80 , 0 ) ,
          defColumn( 'Nachname' , 'Nachname' , 150 , 0 ) ,
          defColumn( 'Vorname' , 'Vorname' , 100 , 0 ) ,
          defColumn( 'Geburtsdatum' , 'Geb.datum' , 50 , 0 ) ,
          defColumn( 'Taetigkeit' , 'Tätigkeit' , 200 , 0 ) ,
          defColumn( 'Abteilung' , 'Abteilung' , 200 , 0 ) ,
        ]
      mkUnterweisungsColumns( cols )
      return cols
    }
  /** Component Mount-Update */
    useEffect(
      () =>
        {
          setLocalUnterweisungsthemen(
            appUnterweisungsthemen
              .filter(
                ( entry ) => entry.UnterweisungsthemenAktiv === 'aktiv'
              )
          ) ;
        } ,
        [ appUnterweisungsthemen ]
    ) ;
    useEffect(
      () => {
        //#region Startzeit als potentieller Trigger
          /** Startzeit für Durchlauf - evtl. später verwenden für Erzwingung Re-Rendering
           *  - konkret für Zurücksetzen Checkboxen in Matrix ist u.U. ein Re-Rendern nötig,
           *    auch wenn sich die eigentlichen Date nicht geändert haben, deshalb "settime"
           *    dann als künstlich geänderte Daten
           *    - noch unklar: wo kann man "settime" platzieren, ohne dass es zuviel Last
           *      erzeugt? ist eine eigene Spalte viel Last oder verhältnismäßig wenig?
           *    - NB: die Checkboxes liegen in DataGrid, i.e. ohne direkten Zugriff; auch
           *      bei direktem Zugriff würde vermutlich jede Checkbox-Änderung ein separates
           *      Re-Rendern auslösen, deshalb besser Komplett-Re-Rendern
           */
            // let starttime = Date.now() ;
            // console.log( 'useEffect Matrix ' + starttime ) ;
            //#endregion Startzeit als potentieller Trigger
        //#region Helper-Funktion mkMatrtixData
          /** historisch gewachsen als Funktion, evtl. umstellbar zu unmittelbarem Code */
            const mkMatrixData = () => {
              //#region Row-Liste initialisieren
                /** DataGrid erwartet Array */
                  let matrixData = [] ;
                  //#endregion Row-Liste initialisieren
              //#region Row pro Mitarbeiter generieren
                /** muss jeweils komplett lokal (neu) initialisiert werden, damit nicht Referenzen
                 *  auf vorherige Rows statt tatsächlich neuen Rows hinzugefügt werden
                 */
                  appMitarbeiterListe
                    .filter(
                      ( entry ) => entry.MitarbeiterAktiv === 'aktiv'
                    )
                    .forEach(
                      ( entry ) =>
                        {
                          //#region Mitarbeiter-Zeile initialisieren
                            let matrixDataRow = {} ;
                              //#endregion Mitarbeiter-Zeile initialisieren
                          //#region Mitarbeiterdaten
                            /** MitarbeiterId für Weiterverarbeitung und als eindeutige RowId = key für DataGrid */
                              matrixDataRow.MitarbeiterId = entry.MitarbeiterId ;
                            /** Anzuzeigende Daten */
                              matrixDataRow.Personalnummer = entry.MitarbeiterPersonalnummer ;
                              matrixDataRow.Nachname = entry.MitarbeiterNachname ;
                              matrixDataRow.Vorname = entry.MitarbeiterVorname ;
                              matrixDataRow.Geburtsdatum = entry.MitarbeiterGeburtsdatum ;
                              matrixDataRow.Taetigkeit = entry.MitarbeiterTaetigkeit ;
                              matrixDataRow.Abteilung = entry.MitarbeiterAbteilung ;
                              //#endregion Mitarbeiterdaten
                          //#region Unterweisungsdaten
                            //#region Spalten für Unterweisungsthemen
                              /** Hinzufügen für neue Unterweisung, Status letzte Unterweisung, evtl. bereits geplante Unterweisung */
                              /** Rückgabe für Anzeige + Sortierung: Tupel "colorString,hourglassBool"
                               *    - colorString: 'green' | 'red' | 'yellow'
                               *      - keine Abkürzungen, da diese wieder rechenintensiv ausgewertet werden
                               *        müssten
                               *    - hourglassBool: '1' | nil
                               *      - für (hoffentlich) unaufwändigste Auswertung
                               *      - Logik: "if( tupel.split(1)[1] == '' )" => hourglassTRUE
                               *        => wenn mit "1" als Splitter das Feld 1 nicht "undefined" ist sondern leer,
                               *           dann war eine "1" angegeben
                               *    - Bsp.:
                               *      - "red" = roter Daumen, keine Sanduhr
                               *      - "red1" = roter Daumen und Sanduhr
                               */
                              //#region Vorhandene Unterweisungsthemen iterieren
                                  localUnterweisungsthemen.forEach(
                                    ( { UnterweisungsthemenId } ) =>
                                      {
                                        let myDates = [] ;
                                        //#region Vorhandene Unterweisungstermine iterieren
                                          //#region Reduktion auf Unterweisungen zum Thema
                                            myDates = appUnterweisungen.filter(
                                              ( unterweisung ) => unterweisung.UnterweisungenThema === UnterweisungsthemenId
                                            )
                                            //#region Reduktion auf Unterweisungen mit Mitarbeiter als Teilnehmer
                                              myDates = myDates.filter(
                                                ( unterweisung ) => ( ( ',' + unterweisung.UnterweisungenMitarbeiter + ',').includes( ',' + entry.MitarbeiterId + ',' ) ) 
                                              )
                                              // console.log( 'myDates für ' + entry.MitarbeiterNachname + ' betrefffs ' + UnterweisungsthemenId + ': ' + myDates )
                                              //#region Auswerten
                                                /** Newest: ID für neueste stattgefundene Unterweisung zum Thema
                                                 *  - bleibt leer wenn = bislang noch nie Unterweisung stattgefunden
                                                 */
                                                  let myNewest = '' ;
                                                /** Daumen: Default "red"
                                                 *  - trifft zu für "überhaupt keine Unterweisung vorhanden" und "Unterweisung abgelaufen"
                                                 *  - zu überschreiben in allen anderen Fällen
                                                 */
                                                  let myDaumen = 'red' ;
                                                /** Planned: ID für geplante Unterweisung zum Thema
                                                 *  - bleibt leer wenn = aktuell keine Unterweisung geplant
                                                 */
                                                  let myPlanned = '' ;
                                                /** Gefundene Unterweisungen prüfen  */
                                                  if( myDates.length !== 0 ) {
                                                    //#region Abgeschlossene auswerten
                                                      let myDatesAbgeschlossen = myDates.filter(
                                                        ( unterweisung ) => unterweisung.UnterweisungenStatus === 'abgeschlossen' 
                                                      )
                                                      if( myDatesAbgeschlossen.length !== 0 ) {
                                                        /** TODO rot vs. gelb vs. grün bezüglich Turnus lt. Unterweisungsthema
                                                         *  - i.e. abgelaufen, bald ablaufend (3 Monate!), noch ausreichend gültig
                                                        */
                                                        // MOCK grün
                                                        myDaumen = 'green' ;
                                                        /** ID für neueste gefundene Unterweisung */
                                                          let myDatesAbgeschlossenNewest = myDatesAbgeschlossen.sort(
                                                            ( a , b ) =>
                                                              {
                                                                if ( a.UnterweisungenTermin > b.UnterweisungenTermin ) { return 1 ; }
                                                                if ( a.UnterweisungenTermin < b.UnterweisungenTermin ) { return -1 ; }
                                                                return 0 ;
                                                              }
                                                          )
                                                          myNewest = myDatesAbgeschlossenNewest[ 0 ].UnterweisungenId ;
                                                      }
                                                        //#endregion Abgeschlossene auswerten
                                                    //#region auf offene prüfen = Sanduhr
                                                      /** Reine Existenzprüfung genügt */
                                                        let myDatesOpen = myDates.filter(
                                                          ( unterweisung ) => unterweisung.UnterweisungenStatus === 'offen' 
                                                        )
                                                        if ( myDatesOpen.length !== 0 ) {
                                                          /** ID für neueste gefundene Unterweisung */
                                                            let myDatesOpenNext = myDatesOpen.sort(
                                                              ( a , b ) =>
                                                                {
                                                                  if ( a.UnterweisungenTermin > b.UnterweisungenTermin ) { return 1 ; }
                                                                  if ( a.UnterweisungenTermin < b.UnterweisungenTermin ) { return -1 ; }
                                                                  return 0 ;
                                                                }
                                                            )
                                                          myPlanned = myDatesOpenNext[ 0 ].UnterweisungenId ;
                                                        }
                                                        //#endregion auf offene prüfen = Sanduhr
                                                  }
                                                /** Resultat setzen  */
                                                  matrixDataRow[ 'matrixUnterweisungsthema' + UnterweisungsthemenId ] = myDaumen + ',' + myNewest + ',' + myPlanned ;
                                                  //#endregion Auswerten
                                                //#endregion Reduktion auf Unterweisungen mit Mitarbeiter als Teilnehmer
                                              //#region Reduktion auf Unterweisungen zum Thema
                                            //#endregion Vorhandene Unterweisungstermine iterieren
                                      }
                                  )
                                  //#endregion Vorhandene Unterweisungsthemen iterieren
                                //#endregion Spalten für Unterweisungsthemen
                              //#endregion Unterweisungsdaten
                          matrixData.push( matrixDataRow ) ;
                        }
                    )
                  //#endregion Row-Liste initialisieren
              // console.log( 'async??:', matrixData ) ;
              return matrixData
            }
            //#endregion Helper-Funktion mkMatrtixData
        setTableData( mkMatrixData() )
        appUnterweisungenMatrixBuildNewChange( false ) ;
        // console.log( 'useEffect Matrix Out ' + Date.now() ) ;
      } ,
      [ appUnterweisungenMatrixBuildNew , appUnterweisungen , localUnterweisungsthemen , appMitarbeiterListe ]
    ) 
/** Component UI */
    return (
      <IonCard>
        <IonCardHeader>
          <IonCardTitle>
            Überblick
          </IonCardTitle>
        </IonCardHeader>
        <IonCardContent>
          {/* <IonButton
            onClick={ () => setMatrixLoading( true ) }
          >
            TEST: Loading-Spinner start
          </IonButton> */}
          <IonLoading
            isOpen = { matrixLoading }
            onDidDismiss={() => setMatrixLoading( false ) }
            message = '  .'
            // message = { localUnterweisungsthemen.length + ', ' + appMitarbeiterListe.length }
            duration = { 
              localUnterweisungsthemen.length > 0
                ? 
                  localUnterweisungsthemen.length * ( appMitarbeiterListe.length + 1)  * 3
                :
                  3000
            }
          />
          <Box
              sx={{
                height: 500 ,
                width: 1,
                "& .super-app-theme--header": {
                  backgroundColor: "rgb(211,211,211)",
                },
              }}
            >
              {
                appUnterweisungenListeFetchState === 100 ? (
                  <IonSpinner name="bubbles" />
                ) : (
                  <DataGrid
                    headerHeight = { 120 }
                    // "loading" muss offenbar anderweitig wieder auf "false" gesetzt werden
                    // loading = { true }
                    disableVirtualization
                    /** sorting: appMitarbeiterListe initial nach Nachname sortiert, also auch matrixData */ 
                      // initialState={{
                      //   sorting: {
                      //     sortModel: [ { field: 'Nachname' , sort: 'asc' } ] ,
                      //   },
                      // }}
                    getRowId = { (row) => row.MitarbeiterId }
                    rows={ tableData }
                    columns={ setColumns() } 
                    rowsPerPageOptions={[50,100]}
                    disableSelectionOnClick
                    onCellClick = {
                      ( e ) => { 
                          // appViewSwitchChange( true ) ;
                          // alert( 'Die Funktionalität zum Aktualisieren der Unterweisungen pro MitarbeiterIn wird derzeit technisch überarbeitet und steht in Kürze wieder zur Verfügung.\n\nWir danken für Ihr Verständnis!' ) ;
                        // alert( e.field + ': ' + e.value )
                        return ;
                      }
                    }
                    pageSize={pageSize}
                    onPageSizeChange={(newPage) => setPageSize(newPage)}
                    pagination
                    localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
                  />
                )
              }
          </Box>
          {
            appUnterweisungen.length > 0
              ?
                <IonButton onClick={ () => exportTableData( tableData , 'Unterweisungen Übersicht' ) }>Exportieren</IonButton>
              :
                ''
          }
          {
            appUnterweisungNeuThema !== ''
              ?
                <IonButton onClick={ () => { appViewSwitchChange( true ) ; appUnterweisungIdChange( 'neu' ) ; history.push( "/unterweisung/neu/" ) ; } }>Neue Schulung "{ unterweisungNeuThemaTitel }"</IonButton>
              :
                <IonButton disabled = { true }>Neue Schulung</IonButton>
            }
        </IonCardContent>
      </IonCard>
    );
}
